/* eslint-disable */
function setUpAutocomplete(data) {
	data.map((element) => {
		const form = document.getElementById(element.form);
		if (form) {
			const ids = element.ids;
			for (let key in ids) {
				if (ids.hasOwnProperty(key)) {
					if (!element.excludes.includes(ids[key])) {
						const field = getField(ids[key], form);
						if (field) {
							initializeAutocomplete(field, element);
						}
					}
				}
			}
		}
	});
}

function getField(id, form) {
	return id ? form.querySelector(`#${id}`) : null;
}

function initializeAutocomplete(field, element) {
	const autocomplete = new google.maps.places.Autocomplete(field, {
		componentRestrictions: { country: 'AU' },
	});

	autocomplete.addListener('place_changed', function () {
		const place = autocomplete.getPlace();
		const address = getAddressFromPlace(place);
		setFormFields(address, element);
	});
}

function getAddressFromPlace(place) {
	const address = {
		postcode: '',
		city: '',
		state: '',
		addressLine1: '',
		addressLine2: '',
	};

	place.address_components.forEach(function (component) {
		const types = component.types;

		if (types.includes('postal_code')) {
			address.postcode = component.long_name;
		} else if (types.includes('locality')) {
			address.city = component.long_name;
		} else if (types.includes('administrative_area_level_1')) {
			address.state = component.short_name;
		} else if (types.includes('route')) {
			address.addressLine1 = component.long_name;
		} else if (types.includes('street_number')) {
			address.addressLine1 += ' ' + component.long_name;
		} else if (types.includes('sublocality_level_1')) {
			address.addressLine2 = component.long_name;
		}
	});

	return address;
}

function setFormFields(address, element) {
	const ids = element.ids;
	for (let key in ids) {
		if (ids.hasOwnProperty(key)) {
			const element = document.getElementById(ids[key]);
			if (element) {
				element.value = address[key];
			}
		}
	}
}

const dataMap = [
	{
		form: 'ProfileManagementForm_getForm',
		ids: {
			addressLine1: 'ProfileManagementForm_getForm_Member_AddressLine1',
			addressLine2: 'ProfileManagementForm_getForm_Member_AddressLine2',
			city: 'ProfileManagementForm_getForm_Member_AddressCity',
			postcode: 'ProfileManagementForm_getForm_Member_AddressPostcode',
			state: 'ProfileManagementForm_getForm_Member_AddressState',
		},
		excludes: ['ProfileManagementForm_getForm_Member_AddressState'],
	},
	{
		form: 'SaleAdEditForm_getForm',
		ids: {
			city: 'SaleAdEditForm_getForm_Suburb',
			addressLine1: null,
			addressLine2: null,
			postcode: null,
			state: 'SaleAdEditForm_getForm_State',
		},
		excludes: ['SaleAdEditForm_getForm_State'],
	},
];

window.addEventListener('load', () => {
	setUpAutocomplete(dataMap);
});
